import * as React from "react";
import { PulseBetButton } from "../../../../components/PulseBetButton";
import { AcceptedBetModel } from "../../data";

const baseClass = "rj-pulse-bet-market__accepted-bet";

export class AcceptedBet extends React.Component<{
    data: AcceptedBetModel
}, {}> {
    //currently for the handler it is unclear what it should do from bussiness side so for now we removing onClick
    render() {
        return (
            <div className={`${baseClass}-container`} onClick={this.props.data.areaHandler}>
                <div className={`${baseClass}-message`}>{this.props.data.message}</div>
                <div className={`${baseClass}-ticket-container`}>
                    <span className={`${baseClass}-interval`}>{this.props.data.timeInterval}</span>
                    <span className={`${baseClass}-ticket`}>{this.props.data.ticketLabel}</span>
                    <span className={`${baseClass}-number`}>{this.props.data.ticketId}</span>
                </div>

                <PulseBetButton modifier="accepted-bet" handler={this.props.data.handler}>
                    {this.props.data.buttonLabel}
                </PulseBetButton>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./blocks/PulseBetMarkets/components/AcceptedBet/AcceptedBet.tsx